import { render } from "./BlogFooter.vue?vue&type=template&id=0dc27b5c"
import script from "./BlogFooter.vue?vue&type=script&lang=js"
export * from "./BlogFooter.vue?vue&type=script&lang=js"

import "./BlogFooter.vue?vue&type=style&index=0&id=0dc27b5c&lang=css"

import exportComponent from "D:\\도연희\\vuestudy\\miniblog\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__